import { z } from 'zod';

export const SearchFileRequestSchema = z
  .object({
    LaboratoryId: z.string(),
    S3Bucket: z.string().optional(),
    S3Prefix: z.string(),
    FileName: z.string().min(1),
    RunId: z.string().uuid().optional(),
  })
  .strict();

export const SearchFileResponseSchema = z.union([
  z
    .object({
      Found: z.literal(true),
      S3Key: z.string(),
      Size: z.number(),
      LastModified: z.string(),
    })
    .strict(),
  z
    .object({
      Found: z.literal(false),
      Reason: z.enum(['TIMEOUT', 'NOT_FOUND']).optional(),
    })
    .strict(),
]);
